import { render } from "./ServiceMvnoOperationsSettings.vue?vue&type=template&id=1ac861e8&scoped=true"
import script from "./ServiceMvnoOperationsSettings.vue?vue&type=script&lang=js"
export * from "./ServiceMvnoOperationsSettings.vue?vue&type=script&lang=js"

import "./ServiceMvnoOperationsSettings.vue?vue&type=style&index=0&id=1ac861e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ac861e8"]])

export default __exports__